/**
 * Labstep
 */

import EntityActionRevoke from 'labstep-web/components/Entity/Action/Revoke';
import { EntityActionTag } from 'labstep-web/components/Entity/Action/Tag';
import { EntityActionTransferOwnership } from 'labstep-web/components/Entity/Action/TransferOwnership';
import { EntityUserActionManage } from 'labstep-web/components/EntityUser/Action/Manage';
import { OrderRequestActionDelete } from 'labstep-web/components/OrderRequest/Action/Delete';
import { OrderRequestActionDuplicate } from 'labstep-web/components/OrderRequest/Action/Duplicate';
import { OrderRequestActionUpdatePurchaseOrder } from 'labstep-web/components/OrderRequest/Action/SetPurchaseOrder';
import { OrderRequestActionShare } from 'labstep-web/components/OrderRequest/Action/Share';
import colDefActionMenu from 'labstep-web/grid/Index/coldefs/Entity/actionMenu';
import type { Entity } from 'labstep-web/models/entity.model';
import type { OrderRequest } from 'labstep-web/models/order-request.model';

export const colDefOrderRequestActionMenu = colDefActionMenu<Entity>(
  (params) => (
    <>
      <OrderRequestActionUpdatePurchaseOrder
        orderRequest={params.data as OrderRequest}
        currency={(params.data as OrderRequest).currency}
      />
      <OrderRequestActionShare
        orderRequest={params.data as OrderRequest}
      />
      <OrderRequestActionDuplicate
        orderRequest={params.data as OrderRequest}
      />
      <EntityUserActionManage entity={params.data as OrderRequest} />
      <EntityActionTag parentEntity={params.data as OrderRequest} />
      <EntityActionRevoke entity={params.data as OrderRequest} />
      <EntityActionTransferOwnership
        entity={params.data as OrderRequest}
      />
      <OrderRequestActionDelete
        orderRequest={params.data as OrderRequest}
      />
    </>
  ),
);
